import React from 'react';
import TabContainer from '../../../../../common/components/tab/containers/tab.containers';
import  { OneProductSettingsComponent } from './one-product-settings.component';

export const OneSettingsComponent = ({ handleInnerFormChange, selectOneSettings, handleFormSubmit }: any) => {

  const tabItems=[
    {
        id:1,
        title:'ONE Settings',
        component:<OneProductSettingsComponent
        selectOneSettings={selectOneSettings} 
        handleInnerFormChange={handleInnerFormChange}
    />,
    isVisible:true,
    }
  ]
  
  return (
    <div className="flex flex-col items-center w-full px-5 overflow-auto h-screen">
       
    <TabContainer tabItems={tabItems} />
  
      <div className='flex w-full justify-end items-end'>
        <button
          className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
            onClick={handleFormSubmit}
            type="submit"
        >
          Save
        </button>
      </div>
    </div>
  );
};

export default OneSettingsComponent;
